import { cmdSendTutorCompleted } from '../../general/modules/webAppFunctions';

export class SendTutorCompletedHandler {
    public handle(): void {
        cmdSendTutorCompleted();
    }
}
